module.exports = __webpack_public_path__ + "static/media/tickIcon.09aa0a90.svg";